import React from 'react';

const Cell = ({ row, col, value, isGiven, notes, isSelected, isPeer, isSameNumber, isError, onClick }) => {
  const isRightBorder = col === 2 || col === 5;
  const isBottomBorder = row === 2 || row === 5;

  const bgClass = isSameNumber
    ? 'bg-indigo-300 dark:bg-indigo-700'
    : isSelected
    ? 'bg-indigo-300 dark:bg-indigo-700'
    : isPeer
    ? 'bg-indigo-50 dark:bg-gray-700'
    : 'bg-white dark:bg-gray-900';

  // Sticky :hover on touch would otherwise override selected/same-number fills until the next tap.
  const hoverClass =
    !isSelected && !isSameNumber && !isError
      ? 'hover:bg-indigo-100 dark:hover:bg-gray-700'
      : '';

  // Lock focus/active fills so Android UA overlays cannot lighten the tapped match/selected cell.
  const matchFillLock =
    isSameNumber || isSelected
      ? 'focus:bg-indigo-300 active:bg-indigo-300 dark:focus:bg-indigo-700 dark:active:bg-indigo-700'
      : '';

  const textClass = isGiven
    ? 'text-gray-600 dark:text-gray-300 font-semibold'
    : 'text-indigo-700 dark:text-indigo-300 font-bold';

  const borderClass = [
    isRightBorder ? 'border-r-2 border-r-gray-700 dark:border-r-gray-400' : '',
    isBottomBorder ? 'border-b-2 border-b-gray-700 dark:border-b-gray-400' : '',
  ].join(' ');

  const errorClass = isError ? 'animate-shake bg-red-200 dark:bg-red-900' : '';

  return (
    <button
      type="button"
      onClick={() => onClick(row, col)}
      className={`relative aspect-square flex items-center justify-center border border-gray-300 dark:border-gray-600 text-xl sm:text-2xl transition-colors duration-150 touch-manipulation [-webkit-tap-highlight-color:transparent] focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 ${hoverClass} ${matchFillLock} ${bgClass} ${textClass} ${borderClass} ${errorClass}`}
    >
      {value !== 0 ? (
        value
      ) : notes.length > 0 ? (
        <div className="grid grid-cols-3 grid-rows-3 w-full h-full text-[8px] sm:text-[10px] text-gray-500 dark:text-gray-400 leading-none p-0.5">
          {Array.from({ length: 9 }, (_, i) => i + 1).map(n => (
            <div key={n} className="flex items-center justify-center">
              {notes.includes(n) ? n : ''}
            </div>
          ))}
        </div>
      ) : null}
    </button>
  );
};

export default Cell;
